module.exports = __webpack_public_path__ + "img/about-md.3b875ce9.svg";